import { defineMessages } from 'react-intl'

export default defineMessages({
  deleted: {
    id: 'containers.CustomerOrderUpsertPage.components.Files.deleted',
    defaultMessage: 'Deleted',
  },
  upload: {
    id: 'containers.CustomerOrderUpsertPage.components.Files.upload',
    defaultMessage: 'Upload a file',
  },
  dragDrop: {
    id: 'containers.CustomerOrderUpsertPage.components.Files.dragDrop',
    defaultMessage: 'or drag and drop',
  },
  audioFormats: {
    id: 'containers.CustomerOrderUpsertPage.components.Files.audioFormats',
    defaultMessage: 'MP3, WAW, DOCX, PDF up to 50MB',
  },
  dropZoneError: {
    id: 'containers.CustomerOrderUpsertPage.components.Files.dropZoneError',
    defaultMessage: '{fileName} is too large. Maximum file size allowed is 50MB.',
  },
})